<template>
  <div class="big-file-upload" :class="[disabled || !enabled ? 'ant-upload-disabled' : '']">
    <uploader
      ref="uploader"
      :options="options"
      :autoStart="false"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-progress="onFileProgress"
      @file-error="onFileError"
    >
      <uploader-unsupport></uploader-unsupport>

      <uploader-btn
        v-if="!(disabled || !enabled) && lazyLoaded"
        :single="!multiple"
        :attrs="{ accept: fileType }"
        ref="uploadBtn"
        class="hide-for-print"
      >
        <a-icon type="upload" style="font-size: 13px" />
        <span style="letter-spacing: 1px; margin-left: 5px; margin-bottom: 2px">上传</span>
      </uploader-btn>

      <uploader-list v-show="panelShow">
        <div slot-scope="props">
          <ul>
            <template v-for="file in props.fileList">
              <li
                :key="file.id"
                v-if="XEUtils.filter(fileList, (r) => r.identifier === file.uniqueIdentifier).length === 0"
              >
                <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true"></uploader-file>
              </li>
            </template>
          </ul>
        </div>
      </uploader-list>
    </uploader>

    <div
      v-if="(forceDownload || (showDownload && (disabled || !enabled))) && fileList.length > 1"
      class="download-wrapper"
    >
      <a-button class="action-btn" @click="downloadAll()" style="line-height: 29px !important">
        <a-icon type="download" style="top: 2px; position: relative; font-size: 13px" />
        <span style="letter-spacing: 1px; margin-left: 5px; height: 28px">下载</span>
      </a-button>
    </div>

    <div class="ant-upload-file-list" v-for="file in fileList" :key="file.uid">
      <a-icon type="paper-clip" />

      <a
        target="_blank"
        :href="file.url"
        rel="noopener noreferrer"
        :disabled="$getLoginUser() && $getLoginUser().username == 'guest'"
      >
        <span>{{ removeTimestamp(file.fileName) }}</span>

        <a-icon type="zoom-in" class="action enter-x" title="预览" @click.prevent="preview(file.url)" />

        <a-icon
          type="scissor"
          class="action enter-x-1"
          title="移除"
          @click.prevent="handleDelete(file.id)"
          v-if="!(disabled || !enabled)"
        />
      </a>
    </div>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import { getAction, postAction, putAction } from '@/api/manage'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getFileAccessHttpUrl } from '@/api/manage'

const ACCEPT_CONFIG = {
  image: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
  video: ['.mp4', '.rmvb', '.mkv', '.wmv', '.flv'],
  document: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.txt', '.tif', '.tiff', '.zip', '.7z', '.rar'],
  getAll() {
    return [...this.image, ...this.video, ...this.document]
  },
}
const uidGenerator = () => {
  return '-' + parseInt(Math.random() * 10000 + 1, 10)
}
const getFileName = (path) => {
  if (path.lastIndexOf('\\') >= 0) {
    let reg = new RegExp('\\\\', 'g')
    path = path.replace(reg, '/')
  }
  return path.substring(path.lastIndexOf('/') + 1)
}

export default {
  name: 'JBigFileUpload',
  inject: ['preview'],
  data() {
    return {
      options: {
        // 目标上传 URL，默认POST
        target: window._CONFIG['domianURL'] + '/sys/common/bigFileUpload',
        // 分块大小(单位：字节)
        chunkSize: 5 * 1024 * 1000,
        simultaneousUploads: 1,
        // 上传文件时文件内容的参数名，对应chunk里的Multipart对象名，默认对象名为file
        fileParameterName: 'file',
        // 失败后最多自动重试上传次数
        maxChunkRetries: 2,
        // 是否开启服务器分片校验，对应GET类型同名的target URL
        testChunks: true,
        /*
        服务器分片校验函数，判断秒传及断点续传,传入的参数是Uploader.Chunk实例以及请求响应信息
        reponse码是successStatuses码时，才会进入该方法
        reponse码如果返回的是permanentErrors 中的状态码，不会进入该方法，直接进入onFileError函数 ，并显示上传失败
        reponse码是其他状态码，不会进入该方法，正常走标准上传
        checkChunkUploadedByResponse函数直接return true的话，不再调用上传接口
        */
        checkChunkUploadedByResponse: function (chunk, message) {
          let objMessage = JSON.parse(message)
          if (objMessage.skipUpload) {
            return true
          }
          return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
        },
        headers: function () {
          const token = Vue.ls.get(ACCESS_TOKEN)
          const dds = Vue.ls.get('DDS')
          return { 'X-Access-Token': token, DDS: dds }
        },
        query() {},
      },
      attrs: {
        accept: this.fileType,
      },
      panelShow: false, //选择文件后，展示上传panel
      lazyLoaded: false,
      fileList: [],
      urlDownload: window._CONFIG['staticDomainURL'],
      url: {
        fileMerge: '/sys/common/bigFileMerge',
      },
    }
  },
  props: {
    fileType: {
      type: String,
      required: false,
      default: ACCEPT_CONFIG.getAll(),
    },
    fileSize: {
      type: Number,
      required: false,
      default: 2,
    },
    /*这个属性用于控制文件上传的业务路径*/
    bizPath: {
      type: String,
      required: false,
      default: 'temp',
    },
    value: {
      type: [String, Array],
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    enabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDownload: {
      type: Boolean,
      required: false,
      default: true,
    },
    forceDownload: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * jun@20220826 for:只保留一个附件
     */
    onlyOneFile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    //Uploader实例
    uploader() {
      return this.$refs.uploader.uploader
    },
  },
  mounted() {
    this.fileList = []
    this.panelShow = false
    this.initFileList(this.value)

    // hong@2022-06-13 不推迟加载的话,有些页面会出JS错误(reading 'assignBrowse')
    setTimeout(() => {
      this.lazyLoaded = true
    }, 1)
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.initFileList(newVal)
      },
      immediate: false,
    },
  },
  methods: {
    removeTimestamp(before) {
      var after = before.replace(/_\d{4}\d{2}\d{2}\d{2}\d{2}\d{2}/, '')
      return after
    },
    initFileList(value) {
      if (value && !this.panelShow) {
        this.fileList = []
        let existFileList = value.split(',')
        existFileList.forEach((item) => {
          let fileInfo = {
            id: uidGenerator(),
            fileName: getFileName(item),
            filePath: item,
            url: getFileAccessHttpUrl(item, this.urlDownload, 'http'),
          }

          this.fileList.push(fileInfo)
        })
      } else if (!value) {
        this.fileList = []
      }
    },
    onFileAdded(file) {
      if (this.beforeUpload(file)) {
        this.panelShow = true
        this.computeMD5(file)
      } else {
        file.cancel()
      }
    },
    onFileProgress(rootFile, file, chunk) {
      console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
    },
    onFileSuccess(rootFile, file, response, chunk) {
      let res = JSON.parse(response)

      if (!res.success) {
        //
        this.$notification.error({
          message: this.$t('disp.error'),
          description: (
            <span>
              <span style="color:darkorange;">{rootFile.name}</span>
              {' 上传失败，请再次尝试'}
            </span>
          ),
        })
        // 合并出错时移除当前file
        XEUtils.remove(this.uploader.fileList, (r) => r.uniqueIdentifier == rootFile.uniqueIdentifier)
        return
      }

      // TODO 如有需要 解开注释 和后台协议如何处理这种情况:服务器自定义的错误（即虽返回200，但是是错误的情况），这种错误是Uploader无法拦截的
      // if (!res.result) {
      //   this.$message({message: res.message, type: 'error'});
      //   // 文件状态设为“失败”
      //   this.statusSet(file.id, 'failed');
      //   return
      // }

      // 如果服务端返回需要合并
      if (res.needMerge) {
        // // 文件状态设为“合并中”
        // this.statusSet(file.id, 'merging')
        let param = {
          fileName: rootFile.name,
          identifier: rootFile.uniqueIdentifier,
          totalSize: rootFile.size,
          bizPath: this.bizPath,
        }

        postAction(this.url.fileMerge, param)
          .then((res) => {
            // this.statusRemove(file.id)
            if (res.success) {
              let fileInfo = res.result
              fileInfo.url = getFileAccessHttpUrl(fileInfo.filePath, this.urlDownload, 'http')
              /**
               * jun@20220826 for:只保留一个附件
               */
              if (this.onlyOneFile) {
                this.fileList = []
                this.uploader.fileList = []
              }
              this.fileList.push(fileInfo)
              this.handlePathChange()
            } else {
              // 合并出错时移除当前file
              XEUtils.remove(this.uploader.fileList, (r) => r.uniqueIdentifier == rootFile.uniqueIdentifier)
            }
          })
          .catch((e) => {
            console.log('合并异常,重新发起请求,文件名为:', file.name)
            //由于网络或服务器原因,导致合并过程中断线,此时如果不重新发起请求,就会进入失败的状态,导致该文件无法重试
            file.retry()
          })

        // 不需要合并
      } else if (res.fileInfo) {
        console.log('上传成功')
        let fileInfo = res.fileInfo
        if (XEUtils.filter(this.fileList, (r) => r.fileName == fileInfo.fileName).length > 0) {
          this.$notification.warning({
            message: this.$t('disp.warn'),
            description: (
              <span>
                <span style="color:darkorange;">{file.name}</span>
                {' 已在列表中，请勿重复上传'}
              </span>
            ),
          })
          XEUtils.remove(this.uploader.fileList, (r) => r.uniqueIdentifier == file.uniqueIdentifier)
          return
        }
        fileInfo.url = getFileAccessHttpUrl(fileInfo.filePath, this.urlDownload, 'http')
        /**
         * jun@20220826 for:只保留一个附件
         */
        if (this.onlyOneFile) {
          this.fileList = []
          this.uploader.fileList = []
        }
        this.fileList.push(fileInfo)
        this.handlePathChange()
      }
    },
    onFileError(rootFile, file, response, chunk) {
      this.$message.error('上传失败')
    },

    beforeUpload(file) {
      // 验证文件大小
      if (file.size && file.size > this.fileSize * 1024 * 1024 * 1000) {
        this.$notification.error({
          message: this.$t('disp.error'),
          description: (
            <span>
              {'文件大小请控制在' + this.fileSize + 'GB以下'}
              <br />
              <span style="color:darkorange;">{file.name}</span>
            </span>
          ),
        })

        this.icon = 'upload'
        return false
      }

      return true
    },

    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    computeMD5(file) {
      let fileReader = new FileReader()
      let time = new Date().getTime()
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize = 10 * 1024 * 1000
      let chunks = Math.ceil(file.size / chunkSize)
      let spark = new SparkMD5.ArrayBuffer()
      // 由于计算整个文件的Md5太慢，因此采用只计算第1块文件的md5的方式
      let chunkNumberMD5 = 1

      // // 文件状态设为"计算MD5"
      // this.statusSet(file.id, 'md5')
      file.pause()

      loadNext()

      fileReader.onload = (e) => {
        spark.append(e.target.result)

        if (currentChunk < chunkNumberMD5) {
          currentChunk++
          loadNext()

          //   // 实时展示MD5的计算进度
          //   this.$nextTick(() => {
          //     $(`.myStatus_${file.id}`).text('校验MD5 ' + ((currentChunk / chunks) * 100).toFixed(0) + '%')
          //   })
        } else {
          let md5 = spark.end()
          this.computeMD5Success(md5, file)
          console.log(
            `MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${
              new Date().getTime() - time
            } ms`
          )
        }
      }

      fileReader.onerror = function () {
        this.$message.error(`文件${file.name}读取出错，请检查该文件`)
        file.cancel()
      }

      function loadNext() {
        let start = currentChunk * chunkSize
        let end = start + chunkSize >= file.size ? file.size : start + chunkSize

        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
      }
    },

    computeMD5Success(md5, file) {
      // // 将自定义参数直接加载uploader实例的opts上
      // Object.assign(this.uploader.opts, {
      //   query: {
      //     ...this.params,
      //   },
      // })

      file.uniqueIdentifier = md5
      file.resume()
      // this.statusRemove(file.id)
    },

    close() {
      this.uploader.cancel()

      this.panelShow = false
    },

    /**
     * 新增的自定义的状态: 'md5'、'transcoding'、'failed'
     * @param id
     * @param status
     */
    statusSet(id, status) {
      let statusMap = {
        md5: {
          text: '校验MD5',
          bgc: '#fff',
        },
        merging: {
          text: '合并中',
          bgc: '#e2eeff',
        },
        transcoding: {
          text: '转码中',
          bgc: '#e2eeff',
        },
        failed: {
          text: '上传失败',
          bgc: '#e2eeff',
        },
      }

      //   this.$nextTick(() => {
      //     $(`<p class="myStatus_${id}"></p>`)
      //       .appendTo(`.file_${id} .uploader-file-status`)
      //       .css({
      //         position: 'absolute',
      //         top: '0',
      //         left: '0',
      //         right: '0',
      //         bottom: '0',
      //         zIndex: '1',
      //         'line-height': 'initial',
      //         backgroundColor: statusMap[status].bgc,
      //       })
      //       .text(statusMap[status].text)
      //   })
    },
    statusRemove(id) {
      //   this.$nextTick(() => {
      //     $(`.myStatus_${id}`).remove()
      //   })
    },

    error(msg) {
      this.$notify({
        title: '错误',
        message: msg,
        type: 'error',
        duration: 2000,
      })
    },
    handleDelete(id) {
      let filter = XEUtils.filter(this.fileList, (r) => r.id == id)

      // 从uploader-list中移除
      if (filter.length > 0 && filter[0].identifier) {
        XEUtils.remove(this.uploader.fileList, (r) => r.uniqueIdentifier == filter[0].identifier)
      }
      // 从fileList中移除
      XEUtils.remove(this.fileList, (r) => r.id == id)

      this.handlePathChange()
    },
    handlePathChange() {
      let path = ''
      if (this.fileList.length > 0) {
        path = XEUtils.map(this.fileList, (item) => item.filePath).join(',')
      }
      this.$emit('change', path)
    },
    downloadAll() {
      this.fileList.forEach((r, index) => {
        setTimeout(() => {
          downloadFile(r.url.replaceAll(this.urlDownload, ''))
        }, 500 * index)
      })
    },
  },
  destroyed() {},

  model: {
    prop: 'value',
    event: 'change',
  },
}
</script>

<style scoped lang="less">
.big-file-upload {
  white-space: initial;

  &.inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    & > div {
      display: inline-block;
      padding-right: 15px;
      white-space: nowrap;

      &.uploader {
        padding-right: 10px;
        display: flex;
        align-items: center;

        .uploader-file {
          margin: 0;
          height: 28px;
          line-height: 28px;
        }
      }
    }
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin-bottom: 0;
    line-height: 0;
  }

  li {
    display: inline-block;
    width: 100%;
  }

  .uploader-file {
    height: 31px;
    line-height: 31px;
    font-size: 13px;
    border-bottom: none;
    margin-top: 4px;
    margin-bottom: 2px;
    background: #f8f8f8;
    color: black;
    transition: all 0.3s;

    ///deep/ * {
    //  letter-spacing: 0.7px;
    //}

    &:hover {
      background: #f1f1f1;
    }
  }

  /deep/ .uploader-file-progress {
    background: linear-gradient(90deg, var(--color-primary-1), var(--color-primary-3));
  }

  /deep/ .uploader-file-info {
    transition: all 0.3s;
  }

  /deep/ .uploader-file-name {
    width: calc(50% - 40px);
    text-indent: 10px;
  }

  /deep/ .uploader-file-icon {
    margin-top: 10px;
    margin-right: 15px;
    margin-left: -6px;
    display: none;
  }

  /deep/ .uploader-file-size {
    width: 20%;
    font-size: 13px;
    text-align: right;
  }

  /deep/ .uploader-file-meta {
    display: none;
  }

  /deep/ .uploader-file-status {
    width: 20%;
    text-align: right;
    text-indent: 0px;
    padding-left: 20px;

    & > span > * {
      display: none;
    }

    & > span > *:first-child {
      display: inherit;
    }
  }

  /deep/ .uploader-file-actions {
    width: 40px;
    display: inline-flex;
    align-items: flex-start;
    justify-content: space-evenly;
    padding-top: 7px;
    padding-right: 7px;
    margin-left: 10%;
  }

  /deep/ .uploader-file-actions > span {
    margin: unset;
    float: unset;

    //&.uploader-file-resume,
    //&.uploader-file-pause {
    //  left: -15px;
    //}

    //&.uploader-file-remove {
    //  left: 28px;
    //}
  }
}

.ant-upload-file-list {
  height: 22px;

  .anticon-paper-clip {
    vertical-align: 0;
  }

  a {
    margin-left: 3px;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: calc(100% - 17px);
    top: 4px;
    height: 18px;
    position: relative;
    line-height: 1;

    &::after {
      transition: transform 0.5s !important;
      top: 17px !important;
    }

    &:hover {
      padding-right: 42px;

      .action {
        display: inherit;
      }
    }

    .anticon {
      display: none;
      right: 20px;
      position: absolute;

      &:hover {
        color: var(--color-primary-8);
      }
    }

    .anticon-scissor {
      right: 2px;

      &:hover {
        color: var(--color-red);
      }
    }
  }

  .anticon {
    color: var(--color-grey);
    transition: all 0.3s;
  }
}

.ant-upload-disabled {
  .uploader {
    display: none !important;
  }

  .ant-upload-file-list {
    a {
      &:hover {
        padding-right: 24px;

        .anticon {
          right: 2px;
        }
      }
    }
  }
}

.uploader-btn {
  font-size: 13px;
  border-radius: 0;
  background-color: #fff;
  border-color: #d9d9d9;
  transition: background-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 6%);
  padding: 4px 6px;
  color: var(--color-font);
  height: 28px;
  margin-top: 2px;
  margin-bottom: 2px;
}

.uploader-btn:hover {
  background-color: white;
  color: var(--color-primary-5);
  border-color: var(--color-primary-5);
}

.action-btn {
  min-width: unset !important;
  padding: 0px 6px 0px 6px !important;
  height: 28px !important;
  font-size: 13px !important;
  line-height: 26px !important;
  border-radius: 0px !important;
  display: flex;
  align-items: center;
}

.download-wrapper {
  margin-top: 2px;
  margin-bottom: 4px;
}
</style>
